export default window.Cesium